// External Paths:
export const feedbackForm = "https://form.typeform.com/to/lIIy43xN";

// Social Paths:
export const linkedInPath = "https://www.linkedin.com/company/tillitinvest/";
export const twitterPath = "https://twitter.com/tillitinvest";
export const instagramPath = "https://www.instagram.com/tillitinvest/";
export const youTubePath =
  "https://www.youtube.com/channel/UC9EyCFEoVqBDFsNoK3MDllA";
